<template>
  <div class="index">

    <topNav></topNav>

    <div class="top" :style="{'background-image':'url('+aboutUsNav[curAbout].bg+')','position':'relative','width':'100%','height':'600px','background-size':'auto 100%','background-position':'0px 0px'}">
      <ul class="about_us_nav">
        <li @click="showAbout(0)" :class="[curAbout==0?'itemActive':'itemNoActive']">{{aboutUsNav[0].name}}</li>
        <li @click="showAbout(1)" :class="[curAbout==1?'itemActive':'itemNoActive']">{{aboutUsNav[1].name}}</li>
        <li @click="showAbout(2)" :class="[curAbout==2?'itemActive':'itemNoActive']">{{aboutUsNav[2].name}}</li>
        <li style="border-right:none;" @click="showAbout(3)" :class="[curAbout==3?'itemActive':'itemNoActive']">{{aboutUsNav[3].name}}</li>
        <!-- <li @click="showAbout(4)" :class="[curAbout==4?'itemActive':'itemNoActive']">{{aboutUsNav[4].name}}</li> -->
      </ul>
    </div>

    <!--<img src="static/china_real_estate_industry_green_supply_chain_action.png" style="position:absolute;left:25px;top:150px;width:50%;" />-->
    <div style="position:absolute;left:20px;top:150px;width:68%;text-align:left;" class="brief_1 Impact">Green Supply Chain Action in China’s Real Estate Industry</div>

    <!--<img src="static/under_top_logo.png" style="position:absolute;left:25px;top:200px;width:150px;" />-->

    <div style="position:absolute;left:20px;top:260px;width:55%;text-align:left;" class="brief_1 Impact" v-if="$store.state.language === 'cn'">中国房地产行业<br />绿色供应链行动</div>

    <pageLocation :currentLocation="curPage"></pageLocation>

    <div class="aboutUs" v-if="curAbout==0" style="width:100%;min-height:900px;margin:120px auto 0px auto;">
      <!-- aboutUs start -->
      <!--       
     <div style="width:80%;margin:0 auto"><img src='static/about_us_page_about_us_en_text.png' style="width:200px;display:block;margin:0 auto;"></div>
     <div style="width:80%;margin:0 auto"><img src='static/about_us_page_about_us_ch_text.png' style="width:100px;display:block;margin:10px auto auto auto;"></div> -->

      <div style="width:80%;margin:0 auto;color:#5a6f18" class="brief_1 Impact">
        About GSC Action
      </div>
      <div style="width:80%;margin:0 auto;color:#92ab26" class="brief_1 Impact"  v-if="$store.state.language === 'cn'">关于绿链</div>

      <div style="width:80%;margin:20px auto">
        <img src="static/about_us_top_pic.png" style="width:100%;" />
        <div style="text-align:left;" v-html="curArticleContent.content"></div>

      </div>

      <!--aboutUs end-->
    </div>

    <div class="aboutUs" v-if="curAbout==1" style="width:100%;min-height:900px;margin:120px auto 0px auto;">
      <!-- 行动宣言 start-->
      <!-- 
      
     <div style="width:80%;margin:0 auto"><img src='static/declaration_of_action.png' style="width:150px;display:block;margin:0 auto;"></div>
     <div style="width:80%;margin:0 auto"><img src='static/declaration_of_action_ch_text.png' style="width:100px;display:block;margin:10px auto auto auto;"></div>
 -->

      <div style="width:80%;margin:0 auto;color:#5a6f18" class="brief_1 Impact">
        Declaration Of Action
      </div>
      <div style="width:80%;margin:0 auto;color:#92ab26" class="brief_1 Impact">行动宣言</div>

      <div style="width:80%;margin:20px auto">

        <div style="text-align:left;" v-html="curArticleContent.content"></div>

        <div class="declarationBox">
          <ul class="declarationItem" v-for="(articleItem,index) in aboutUsNav[1].articleList" :key="index">
            <li>
              <img :src="articleItem.imgUrl" style="width:100%; height: 210px" />
            </li>
            <li style="height:70px;overflow:hidden;background:#97c619;color:#fff;width:100%;text-align:left;">
              {{articleItem.articleName}}
            </li>
          </ul>
        </div>

      </div>

      <!--行动宣言 end-->
    </div>

    <div class="aboutUs" v-if="curAbout==2" style="width:100%;min-height:2400px;margin:120px auto 0px auto;">
      <!-- 组织结构 start-->

      <div style="width:80%;margin:0 auto;color:#5a6f18" class="brief_1 Impact">
        Organization Structure
      </div>
      <div style="width:80%;margin:0 auto;color:#92ab26" class="brief_1 Impact">组织结构</div>

      <div style="width:80%;margin:20px auto">

        <!-- <div class="articleContent" style="text-align:left;" v-html="curArticleContent.content.replaceAll('/uploadfile','http://gsc.see.org.cn/uploadfile').replace('height:396px; text-align:justify; width:600px','height:auto; text-align:justify; width:100%').replace('height:553px; width:900px','height:auto; width:100%').replace('height:300px; margin:0px; max-width:100%; padding:0px; text-align:center; width:533px','height:auto; margin:0px; max-width:100%; padding:0px; text-align:center; width:100%')"></div> -->
        <!-- <div class="articleContent articleContentStyle" style="text-align:left;" v-html="curArticleContent.content.replaceAll('/uploadfile','http://gsc.see.org.cn/uploadfile')"></div> -->
        <div class="articleContent articleContentStyle" style="text-align:left;" v-html="curArticleContent.content"></div>

        <!-- <div :class="['articleContent', 'articleContentStyle']" v-html="curArticleContent.content"></div> -->

      </div>

      <!--组织结构 end-->
    </div>

    <div class="aboutUs" v-if="curAbout==3" style="width:100%;min-height:2400px;margin:120px auto 0px auto;">
      <!-- 企业名录 start-->

      <div style="width:80%;margin:0 auto;color:#5a6f18" class="brief_1 Impact">
        Member Directory
      </div>
      <div style="width:80%;margin:0 auto;color:#92ab26" class="brief_1 Impact">房地产企业名录</div>

      <div style="width:80%;margin:20px auto">

        <!-- <div class="articleContent " style="text-align:left;" v-html="curArticleContent.content.replaceAll('/uploadfile','http://gsc.see.org.cn/uploadfile').replace('height:396px; text-align:justify; width:600px','height:auto; text-align:justify; width:100%').replace('height:553px; width:900px','height:auto; width:100%').replace('height:300px; margin:0px; max-width:100%; padding:0px; text-align:center; width:533px','height:auto; margin:0px; max-width:100%; padding:0px; text-align:center; width:100%')"></div> -->
        <div class="articleContent " style="text-align:left;" v-html="curArticleContent.content.replace('height:396px; text-align:justify; width:600px','height:auto; text-align:justify; width:100%').replace('height:553px; width:900px','height:auto; width:100%').replace('height:300px; margin:0px; max-width:100%; padding:0px; text-align:center; width:533px','height:auto; margin:0px; max-width:100%; padding:0px; text-align:center; width:100%')"></div>

      </div>

      <!--企业名录 end-->
    </div>

    <!-- <div class="aboutUs" v-if="curAbout==4" style="width:100%;height:auto;margin:120px auto 0px auto;" > -->
    <!-- 发展历程 start-->

    <!--       
     <div style="width:80%;margin:0 auto"><img src='static/declaration_of_action.png' style="width:150px;display:block;margin:0 auto;"></div>
     <div style="width:80%;margin:0 auto"><img src='static/declaration_of_action_ch_text.png' style="width:100px;display:block;margin:10px auto auto auto;"></div>
     
     <div style="width:80%;margin:20px auto">
  
         <div class="articleContent" style="text-align:left;" v-html="curArticleContent.content.replaceAll('/uploadfile','http://www.cura.cn/uploadfile').replace('height:396px; text-align:justify; width:600px','height:auto; text-align:justify; width:100%').replace('height:553px; width:900px','height:auto; width:100%').replace('height:300px; margin:0px; max-width:100%; padding:0px; text-align:center; width:533px','height:auto; margin:0px; max-width:100%; padding:0px; text-align:center; width:100%')"></div> 
     </div>
  -->

    <!--发展历程 end-->
    <!-- </div> -->

    <img src="static/about_us_bottom_img01.png" v-if="curAbout==0" style="width:100%;display:block;margin-bottom:-2px;" />
    <!--底部组件-->
    <friendLinkAndFooter></friendLinkAndFooter>

  </div>
</template>


<script>
import { articleListByPage, articleDetail } from "@/api";
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import friendLinkAndFooter from '@/components/friendLinkAndFooter'
import topNav from '@/components/topNav'
import pageLocation from '@/components/pageLocation'
export default {
  name: 'aboutUs',
  components: {
    topNav, friendLinkAndFooter, pageLocation
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      showNav: false,
      pages: 1,
      //关于我们当前的页签
      curPage: '关于绿链',
      curAbout: 0,
      curArticleCode: 'WZNR201610311925050031',
      curArticleContent: {},
      aboutUsNav: [
        { 'name': '关于绿链', 'articleCode': 'WZNR201610311925050031', 'catCode': '', 'bg': 'static/about_us_to_bg.png' },
        { 'name': '行动宣言', 'articleCode': 'WZNR201610311925050032', 'catCode': '000001|000037', 'articleList': [], 'bg': 'static/about_us_xdxy_top_bg.png' },
        { 'name': '组织结构', 'articleCode': 'WZNR201610311925050033', 'catCode': '', 'bg': 'static/about_us_top_zzjg_bg.png' },
        { 'name': '企业名录', 'articleCode': 'WZNR201610311925050034', 'catCode': '', 'bg': 'static/about_us_qyml_bg.png' }
        // {'name':'发展历程','articleCode':'000000008','catCode':'','bg':'static/about_us_to_bg.png'}
      ]
    }
  },
  methods: {

    showAbout(n) {
      this.curAbout = n;
      this.curArticleCode = this.aboutUsNav[n].articleCode;
      this.curPage = this.aboutUsNav[n].name;
      this.articleDetail(this.curArticleCode);
      if (n == 1) {
        //如果是行动宣言查询下面的列表
        this.articleListByPage(this.aboutUsNav[n].catCode);

      }
    },
    articleDetail(articleCode) {
      const params = {
        articleId: articleCode,
        isEn: this.$store.state.language === 'en' ? 1 : 0
      }
      articleDetail(params).then((res) => {
        // console.log(res);
        this.curArticleContent = res.data
        // this.list = [res.data]
        // this.content = 
      })

    },

    articleListByPage(catCode) {
      var that = this
      // console.log(this.dateY,' =====____');
      const params = {
        page: that.pages,
        catCode: encodeURIComponent(catCode),
        limit: 99999,
        isEn: this.$store.state.language === 'en' ? 1 : 0
      };
      articleListByPage(params).then(res => {
        console.log(res.data);
        that.aboutUsNav[1].articleList = res.data.list;
      });
    }
  },
  mounted() {
    var that = this;

    //加载新闻
    this.articleDetail('WZNR201610311925050031');



  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// /* @import '@/assets/css/content.css'; */
// @import '../assets/css/content.css';

// img {
//   width: 100% !important;
// }
 .articleContentStyle /deep/ * {
  img {
    width: 100% !important;
    height: auto !important;
  }
}
.brief_1 {
  font-size: 20px;
  font-weight: 900;
  color: #fff;
}
.Impact {
  font-family: Impact, 微软雅黑;
}

.about_us_nav {
  margin: 0px;
  padding: 0px;
  display: flex;
  position: absolute;
  bottom: -20px;
  width: 90%;
  left: 5%;
  box-shadow: #ebebeb 5px 5px 5px 5px;
}
.about_us_nav li {
  margin: 0px;
  padding: 0px;
  width: 25%;
  text-align: center;
  height: 35px;
  line-height: 35px;
  border-right: 1px solid #89a128;
  font-size: 12px;
}

.show {
  display: block;
}
.item {
  width: 100%;
  height: 50px;
  margin: 0px;
  display: block;
}
.itemActive {
  background: #89a128;
  color: #fff;
}
.itemNoActive {
  background: #fff;
  color: #89a128;
}
.hidden {
  display: none;
}
.index {
  margin: 0px;
  padding: 0px;
  width: 100%;
  min-height: 960px;
}

.top {
  position: relative;
  width: 100%;
  height: 600px;
  background-size: auto 100%;
  background-position: 0px 0px;
}

.navBox {
  width: 150px;
}
.navBox li {
  height: 30px;
}
.navBox li a {
  color: #fff;
  text-align: right;
  display: block;
  width: 100%;
  text-decoration: none;
}

.declarationItem {
  width: 45%;
  float: left;
  overflow: hidden;
  margin: 10px 2% 10px 2%;
  padding: 0px;
  height: 260px;
}
.declarationItem li {
  margin: 0px;
  padding: 0px;
}

h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue